import { SeeqNames } from '@/main/app.constants.seeqnames';

const packageName = SeeqNames.MlService.PlsRegression.Connection.UdfPackage;
const udfName = SeeqNames.MlService.PlsRegression.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const DEFAULT_NUM_COMPONENTS = 2;
// NOTE: Set a shorter delay for validation errors in tests to speed up test execution
export const VALIDATION_ERROR_DELAY = process.env.NODE_ENV === 'test' ? 50 : 500;
